import React from "react";
import { Document, Page, View, Text, Image, StyleSheet } from "@react-pdf/renderer";
import { COMPANY_HEADER } from "../lib/company";

export const EVENT_LABEL = { DESTRUCTION: "Destruction", FREEZE: "Congélation", DON_PERSONNEL: "Don personnel" };
const fmt = (iso) => (iso ? new Date(`${String(iso).slice(0, 10)}T00:00:00`).toLocaleDateString("fr-CH") : "—");
const origin = typeof window !== "undefined" ? window.location.origin : "";

const s = StyleSheet.create({
  page: { padding: 30, fontSize: 8, fontFamily: "Helvetica", color: "#1A1C1A" },
  head: { flexDirection: "row", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 12 },
  title: { fontSize: 14, fontFamily: "Helvetica-Bold" },
  sub: { fontSize: 8.5, color: "#575A57", marginTop: 2 },
  th: { flexDirection: "row", backgroundColor: "#F4F4F0", paddingVertical: 4, paddingHorizontal: 3, borderBottom: "1pt solid #CCC" },
  tr: { flexDirection: "row", paddingVertical: 3.5, paddingHorizontal: 3, borderBottom: "0.5pt solid #E5E5E0" },
  b: { fontFamily: "Helvetica-Bold" },
  foot: { position: "absolute", bottom: 18, left: 30, right: 30, fontSize: 7, color: "#A3A6A3", flexDirection: "row", justifyContent: "space-between" },
  sign: { marginTop: 18, flexDirection: "row", gap: 40 },
});

const COLS = [
  ["Date", 0.9, (e) => fmt(e.date)],
  ["Opération", 0.9, (e) => EVENT_LABEL[e.type] || e.type],
  ["Produit", 2.4, (e) => `${e.product_name}${e.product_sku ? ` (${e.product_sku})` : ""}`],
  ["Lot", 1.3, (e) => e.lot_number || "—"],
  ["Qté", 0.5, (e) => String(e.quantity)],
  ["DLC", 0.8, (e) => fmt(e.dlc)],
  ["Détail", 3.2, (e) => (e.type === "FREEZE"
    ? `DDM ${fmt(e.ddm)}${e.notes ? ` — ${e.notes}` : ""}`
    : [e.reason, e.channel_label, e.ref && `Bon ${e.ref}`, e.notes].filter(Boolean).join(" — "))],
];

export default function HaccpRegisterPdf({ data, period }) {
  const t = data.totals || {};
  return (
    <Document>
      <Page size="A4" orientation="landscape" style={s.page}>
        <View style={s.head}>
          <View>
            <Text style={s.title}>Registre HACCP — Destructions, congélations, dons personnel</Text>
            <Text style={s.sub}>{COMPANY_HEADER} · Période : {period}</Text>
            <Text style={s.sub}>Totaux : {t.destroyed || 0} détruite(s) · {t.frozen || 0} congelée(s) · {t.staff || 0} don(s) personnel</Text>
          </View>
          <Image src={`${origin}/logo-maisonthai-pdf.png`} style={{ width: 40, height: 40 }} />
        </View>
        <View style={s.th} fixed>
          {COLS.map(([h, f]) => <Text key={h} style={[s.b, { flex: f }]}>{h}</Text>)}
        </View>
        {data.events.map((e) => (
          <View key={e.id} style={s.tr} wrap={false}>
            {COLS.map(([h, f, fn]) => <Text key={h} style={{ flex: f, paddingRight: 3 }}>{fn(e)}</Text>)}
          </View>
        ))}
        {!data.events.length && <Text style={{ marginTop: 10, color: "#575A57" }}>Aucune opération sur la période.</Text>}
        <View style={s.sign} wrap={false}>
          <Text>Visa responsable autocontrôle : ______________________</Text>
          <Text>Date : ______________</Text>
        </View>
        <View style={s.foot} fixed>
          <Text>Édité le {new Date().toLocaleDateString("fr-CH")}</Text>
          <Text render={({ pageNumber, totalPages }) => `Page ${pageNumber} / ${totalPages}`} />
        </View>
      </Page>
    </Document>
  );
}
